import React from "react";
import { USDollar, formatPeriodLabel, toNumber } from "./utils";

export default function YearMatrix({
  data,
  selectedIndex,
  onSelectPeriod,
  onDrill,
}) {
  const periods = data?.periods || [];
  const ranges = data?.aging_ranges || [];

  return (
    <div className="w-full border rounded-lg overflow-hidden">
      <div className="bg-gray-100 border-b p-3">
        <h2 className="text-sm font-bold">Aging by Month — {data?.year}</h2>
        <p className="text-xs font-extralight text-gray-500">
          Open balance at the last day of each month. Click a cell to drill down,
          click a month header to detail it below.
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr className="bg-gray-50 border-b">
              <th className="text-left p-2 font-semibold text-gray-700 sticky left-0 bg-gray-50">
                Aging
              </th>
              {periods.map((period, index) => (
                <th
                  key={period.period}
                  onClick={() => onSelectPeriod(index)}
                  className={`text-right p-2 font-semibold text-gray-700 cursor-pointer hover:text-mila_orange whitespace-nowrap ${
                    index === selectedIndex ? "text-mila_orange underline" : ""
                  }`}
                >
                  {formatPeriodLabel(period.period)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ranges.map((range, rangeIndex) => (
              <tr
                key={range.key}
                className={`border-b ${
                  rangeIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                }`}
              >
                <td
                  className={`p-2 font-medium sticky left-0 ${
                    rangeIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  {range.label}
                </td>
                {periods.map((period) => {
                  const cell = (period.aging || []).find(
                    (item) => item.key === range.key
                  );
                  const value = toNumber(cell?.sum);
                  return (
                    <td
                      key={`${period.period}-${range.key}`}
                      onClick={() =>
                        value > 0 &&
                        onDrill({
                          reference_date: period.reference_date,
                          aging_key: range.key,
                          title: `${range.label} — ${formatPeriodLabel(
                            period.period
                          )}`,
                        })
                      }
                      className={`p-2 text-right whitespace-nowrap ${
                        value > 0
                          ? "cursor-pointer hover:bg-green-50"
                          : "text-gray-400"
                      }`}
                    >
                      {USDollar.format(value)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-gray-100 border-t-2 border-gray-300 font-bold">
              <td className="p-2 sticky left-0 bg-gray-100">Total</td>
              {periods.map((period) => {
                const value = toNumber(period.totals?.sum);
                return (
                  <td
                    key={`total-${period.period}`}
                    onClick={() =>
                      value > 0 &&
                      onDrill({
                        reference_date: period.reference_date,
                        title: `All aging ranges — ${formatPeriodLabel(
                          period.period
                        )}`,
                      })
                    }
                    className={`p-2 text-right whitespace-nowrap ${
                      value > 0 ? "cursor-pointer hover:bg-green-50" : ""
                    }`}
                  >
                    {USDollar.format(value)}
                  </td>
                );
              })}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
